import { PreviewMode } from "../Models/PreviewMode";
import { AppSettings } from "./AppSettings";
import { Beeper } from "./Beeper";
import { InputState } from "../Models/SensorState";


export class Beepers
{
    private cameraConnectedBeeper = new Beeper("CameraConnection", 2000, 0.2);
    private cameraDisonnectedBeeper = new Beeper("CameraConnection", 500, 0.5);
    private newPictureInLivePreviewModeBeeper = new Beeper("NewPictureInLivePreviewMode", 100, 0.05);
    private newPictureInSnapshotViewModeBeeper = new Beeper("NewPictureInSnapshotViewMode", 50, 0.05);
    private sensorsBeepers: Beeper[] = [];
    private isInitialized = false;

    constructor(private _setts: AppSettings) 
    { }

    public Init(inputsNames: string[]): void
    {
        if (this.isInitialized)
            return;

        this.isInitialized = true;

        this.sensorsBeepers = inputsNames.map((name, index) => new Beeper(name, 650 + index * 100));

        this._setts.Sounds.OnChange((soundsEnabled: boolean) =>
        {
            if (soundsEnabled == false)
            {
                this.StopAll();
            }
        });

        this._setts.SensorsSounds.OnChange((soundsEnabled: boolean) =>
        {
            if (soundsEnabled == false)
            {
                this.StopAll();
            }
        });
    }

    public MakeCameraConnection(isConnected: boolean): void
    {
        if (isConnected)
            this.cameraConnectedBeeper.PlayTones([
                { freq: 1000, volume: 0.3, duration: 0.2 },
                { freq: 1200, volume: 0.5, duration: 0.15 },
            ]);
        else
            this.cameraDisonnectedBeeper.PlayTones([
                { freq: 1200, volume: 0.3, duration: 0.3 },
                { freq: 150, volume: 0.4, duration: 0.8 },
            ]);
    }
    
    public CameraConnection(isConnected: boolean): void
    {
        if (this._setts.Sounds.IsFalse() || this._setts.CameraConnectionSounds.IsFalse())
            return;

        this.MakeCameraConnection(isConnected);
    }

    public StopAll(): void
    {
        this.sensorsBeepers.forEach(b => b.Stop());
        this.cameraConnectedBeeper.Stop();
        this.cameraDisonnectedBeeper.Stop();
        this.newPictureInLivePreviewModeBeeper.Stop();
        this.newPictureInSnapshotViewModeBeeper.Stop();
    }

    public MakeNewPictureSound(mode: PreviewMode): void
    {
        if (mode == PreviewMode.LivePreview && this._setts.NewPictureInLivePreviewMode.IsTrue())
            this.newPictureInLivePreviewModeBeeper.PlayTones([
                { freq: 1140, duration: 0.15 },
                { freq: 920, duration: 0.25 },
            ]);
        else if (mode == PreviewMode.SnapshotView && this._setts.NewPictureInSnapshotViewMode.IsTrue())
            this.newPictureInSnapshotViewModeBeeper.PlayTones([
                { freq: 400, duration: 0.06 },
                // { freq: 800, duration: 0.2 },
            ]);
    }

    public NewPicture(mode: PreviewMode): void
    {
        if (this._setts.Sounds.IsFalse())
            return;

        this.MakeNewPictureSound(mode);
    }

    public InputActive(input: InputState): void
    {
        if (this._setts.Sounds.IsFalse() || this._setts.SensorsSounds.IsFalse())
            return;

        const index = this.sensorsBeepers.findIndex(b => b.Name == input.Name);
        if (index == -1)
            return;

        input.Value ? this.sensorsBeepers[index].Play() : this.sensorsBeepers[index].Stop();
    }

    public StopInput(inputName: string): void
    {
        this.sensorsBeepers.find(b => b.Name == inputName)?.Stop();
    }
}
